import { render } from "./InfoPacientes.vue?vue&type=template&id=b6ac5770&scoped=true"
import script from "./InfoPacientes.vue?vue&type=script&lang=js"
export * from "./InfoPacientes.vue?vue&type=script&lang=js"

import "./InfoPacientes.vue?vue&type=style&index=0&id=b6ac5770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ac5770"]])

export default __exports__